export default __webpack_public_path__ + "static/media/sp_revenue.948869f1.svg";